module.exports = __webpack_public_path__ + "static/media/img002.4f364b79.jpg";